import aaMembership from './airAmbulance';
import keMembership from './kidnapAndExtortion';
import srMembership from './securityResponse';
import docMembership from './dutyOfCare';
import membership from './common';

export const membershipReducers = {
  aaMembership,
  keMembership,
  membership,
  srMembership,
  docMembership,
};
